import { render, staticRenderFns } from "./ViewEmployeesHead.vue?vue&type=template&id=07861b0c&scoped=true&"
import script from "./ViewEmployeesHead.vue?vue&type=script&lang=ts&"
export * from "./ViewEmployeesHead.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEmployeesHead.vue?vue&type=style&index=0&id=07861b0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07861b0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VTextField})
